import { UUID } from 'crypto';
import { requireApp } from 'store/assertions';

const getApiClient = () => requireApp().apiClient;

interface SubsimulationRenameRequest {
    id: number;
    parentSimulationSet: {
        id: UUID;
    };
}

export async function rename(newLabel: string, item: SubsimulationRenameRequest): Promise<void> {
    await getApiClient().patch(`simulation-sets/${item.parentSimulationSet.id}/simulations/${item.id}`, { name: newLabel });
}
